/**
 * @desc 이곳에 router 들을 정리합니다.
 * @information
 * 1. path
 * 2. element
 * @history
 * - 2023.10.05. 기본값 내용 추가
 */
import {createHashRouter} from 'react-router-dom'
// import TestTailwind from '../pages/TestTailwind'
// import ReactiveNavBar from '../components/customs/ReactiveNavBar'
// import Type02 from '../pages/Type02'
// import Error from '../pages/Error'
// import AboutUs from '../components/containers/AboutUs'
// import Type03 from '../pages/Type03'
import PlaceholderHome from 'pages/PlaceholderHome'
import Root from 'pages/Root'
// import Campaigns from 'pages/Campaigns'
// import HowItWorks from 'pages/HowItWorks'
// import CampaignDetail from 'pages/CampaignDetail'
// import CampaignNew from 'pages/CampaignNew'
import ComingSoon from 'pages/ComingSoon'

// const router = [
//   {path: '/', element: <Root />, title: 'MainPage'},
//   {path: '/tailwind', element: <TestTailwind />, title: 'TailwindCSS'},
//   {path: '/reactive-navbar', element: <ReactiveNavBar />, title: 'ReactiveNavBar'},
//   {path: '/about-us', element: <AboutUs />, title: 'Type01'},
//   {path: '/type02', element: <Type02 />, title: 'Type02'},
//   {path: '/type03', element: <Type03 />, title: 'Type03'},
//   {path: '*', element: <Error />, title: '', display: false}
// ]

// const rrouter = [
//   {
//     path: '/',
//     element: <Root />,
//     title: 'Index',
//     children: [
//       {path: '', element: <Type03 />, title: 'Home'},
//       {path: '/about-us', element: <AboutUs />, title: 'Type01'},
//       {path: '/how-it-works', element: <HowItWorks />, title: 'HowItWorks'},
//       {path: '/campaigns', element: <Campaigns />, title: 'Campaigns'},
//       {path: '/campaign-detail', element: <CampaignDetail />, title: 'Campaign Detail'},
//       {path: '/new-campaign', element: <CampaignNew />, title: 'New Campaign'},
//       {path: '*', element: <Error />, title: '', display: false}
//     ]
//   }
// ]

const rrrouter = [
  {
    path: '/',
    element: <Root />,
    title: 'Index',
    children: [
      {path: '', element: <PlaceholderHome />, title: 'Home'},
      {path: '*', element: <ComingSoon />, title: '', display: false}
    ]
  }
]

const cbr_router = createHashRouter(rrrouter)

export {rrrouter, cbr_router}
